<template>
    <div>
        <b-card-actions noActions>
            <validation-observer ref="formObserver" v-slot="{ invalid, validate }">
                <form @submit.prevent="handleSubmit(validate)">
                    <b-tabs content-class="mt-1">
                        <b-tab title="House Pin Section">
                            <b-row>
                                <b-col md="12" v-if="languages.length">
                                    <b-tabs content-class="mt-1">
                                        <b-tab v-for="lang in languages" :key="lang.code" :title="lang.name">
                                            <validated-input
                                                :label="`House Pin (${lang.name})`"
                                                :name="`house_pin_${lang.code}`"
                                                v-model="form.name[lang.code]"
                                                placeholder="Property Pin"
                                                rules="required"
                                            />
                                            <validated-input
                                                :label="`Address (${lang.name})`"
                                                :name="`address_${lang.code}`"
                                                v-model="form.address[lang.code]"
                                                placeholder="Address"
                                            />

                                            <b-row>
                                                <b-col md="6">
                                                    <validated-input
                                                        :label="`Meta Title (${lang.name})`"
                                                        :name="`meta_title_${lang.code}`"
                                                        v-model="form.meta_title[lang.code]"
                                                        :placeholder="`Meta Title (${lang.code})`"
                                                    />
                                                </b-col>
                                                <b-col md="6">
                                                    <validated-input
                                                        :label="`Meta Description (${lang.name})`"
                                                        :name="`meta_description_${lang.code}`"
                                                        v-model="form.meta_description[lang.code]"
                                                        :placeholder="`Meta Description (${lang.code})`"
                                                    />
                                                </b-col>
                                            </b-row>
                                        </b-tab>
                                    </b-tabs>
                                </b-col>

                                <b-col md="12">
                                    <validated-input
                                        label="Youtube URL"
                                        name="youtube"
                                        v-model="form.youtube"
                                        placeholder="Youtube URL"
                                    />
                                </b-col>

                                <b-col md="12" class="q-description">
                                    <b-form-group label="Description">
                                        <quill-editor style="height: 150px" v-model="form.description" />
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-col md="12">
                                <h5>Property Info</h5>
                                <hr />
                            </b-col>
                            <b-row>
                                <b-col md="4">
                                    <b-form-group label="Developer">
                                        <v-select
                                        v-model="form.developer_id"
                                        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        label="name"
                                        :reduce="(option) => option.id"
                                        :options="developerData"
                                        />
                                    </b-form-group>
                                </b-col>

                                <b-col md="4">
                                    <b-form-group label="House Type">
                                        <v-select
                                            v-model="form.type_id"
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                            label="name"
                                            multiple
                                            :reduce="(option) => option.id"
                                            :options="houseTypeOptions"
                                        />
                                    </b-form-group>
                                </b-col>

                                <b-col md="4">
                                    <b-form-group label="Rating">
                                        <b-form-rating
                                        id="rating-lg-no-border"
                                        v-model="form.rating"
                                        no-border
                                        variant="warning"
                                        size="lg"
                                        inline
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col md="4">
                                    <validated-input
                                        label="Year"
                                        name="year"
                                        v-model="form.year"
                                        placeholder="Year"
                                        rules="integer"
                                    />
                                </b-col>

                                <b-col md="4">
                                    <validated-input
                                        label="Total Unit"
                                        name="total_unit"
                                        v-model="form.total_unit"
                                        placeholder="Unit"
                                        rules="integer"
                                    />
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col md="12">
                                    <b-form-group label="Comment">
                                        <b-form-textarea v-model="form.comment" rows="3" placeholder="Comment" />
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-col md="12">
                                <h5>Location</h5>
                                <hr />
                            </b-col>

                            <b-row>
                                <location-selector
                                    label="BTS"
                                    :options="btsOptions"
                                    :data.sync="form.btsData"
                                />

                                <location-selector
                                    label="MRT"
                                    :options="mrtOptions"
                                    :data.sync="form.mrtData"
                                />
                            </b-row>

                            <b-row>
                                <location-selector
                                    label="Airport Link"
                                    :options="airportLinkOptions"
                                    :data.sync="form.airportLinkData"
                                />

                                <b-col md="6">
                                    <b-form-group>
                                        <label>Zone</label>
                                        <v-select
                                            v-model="form.zoneId"
                                            :options="zoneOptions"
                                            label="name"
                                            :reduce="zone => zone.id"
                                            multiple
                                            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                                        />
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col md="3">
                                <b-form-group label="Province">
                                    <v-select
                                    v-model="form.province_id"
                                    :options="provinceOptions"
                                    :reduce="p => p.id"
                                    label="name"
                                    placeholder="Select a province"
                                    @input="onProvinceChange"
                                    />
                                </b-form-group>
                                </b-col>

                                <b-col md="3">
                                <b-form-group label="Amphure/ Khet">
                                    <v-select
                                    v-model="form.amphure_id"
                                    :options="amphureOptions"
                                    :reduce="a => a.id"
                                    label="name"
                                    placeholder="Select an amphure"
                                    @input="onAmphureChange"
                                    :disabled="!form.province_id"
                                    />
                                </b-form-group>
                                </b-col>

                                <b-col md="3">
                                <b-form-group label="District/ Kwaeng">
                                    <v-select
                                    v-model="form.tambon_id"
                                    :options="tambonOptions"
                                    :reduce="t => t.id"
                                    label="name"
                                    placeholder="Select a tambon"
                                    @input="onTambonChange"
                                    :disabled="!form.amphure_id"
                                    />
                                </b-form-group>
                                </b-col>

                                <b-col md="3">
                                <b-form-group label="Zip Code">
                                    <b-form-input :value="form.zip_code" readonly />
                                </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col md="6">
                                    <b-form-group>
                                    <label>Responsible By </label>
                                    <vue-autosuggest
                                        ref="autocomplete"
                                        v-model="form.responsible_id"
                                        :suggestions="suggestionscb"
                                        :input-props="inputProps"
                                        :section-configs="sectionConfigs"
                                        :render-suggestion="renderSuggestioncb"
                                        :get-suggestion-value="getSuggestionValuecb"
                                        @input="fetchResultscb"
                                    />    
                                    </b-form-group>
                                </b-col>

                                <b-col md="6">
                                    <b-form-group>
                                        <label>Active</label>
                                        <b-form-checkbox
                                            v-model="form.is_active"
                                            switch
                                            class="custom-control-primary"
                                        >
                                        </b-form-checkbox>
                                    </b-form-group>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col md="12">
                                    <h5>Map</h5>
                                    <hr />
                                </b-col>

                                <b-col md="6">
                                    <l-map :zoom="zoom" :center="center">
                                        <l-tile-layer :url="url" />
                                        <l-marker :lat-lng="markerLatLng" />
                                        <l-circle
                                            :lat-lng="circle.center"
                                            :radius="circle.radius"
                                            :color="circle.color"
                                        />
                                        <l-polygon
                                            :lat-lngs="polygon.latlngs"
                                            :color="polygon.color"
                                        />
                                    </l-map>
                                </b-col>

                                <b-col md="6">
                                    <b-form-group>
                                        <label>Lattitude</label>
                                            <b-form-input
                                                v-model="form.lattitude"
                                                @change="changePosition"
                                                placeholder="Lattitude"
                                            />
                                        </b-form-group>

                                        <b-form-group>
                                            <label>Longitude</label>
                                                <b-form-input
                                                v-model="form.longitude"
                                                @change="changePosition"
                                                placeholder="Longitude"
                                                />
                                        </b-form-group>

                                        <!-- โซน / สถานี / ที่อยู่ คำนวณจากพิกัดได้ ไม่ต้องกรอกเอง -->
                                        <b-form-group>
                                            <b-button
                                                variant="outline-primary"
                                                size="sm"
                                                :disabled="!hasCoord || isGeoLoading"
                                                @click="checkCoord(false)"
                                            >
                                                ตรวจจากพิกัด
                                            </b-button>
                                            <div class="text-muted mt-25">
                                                <small>
                                                    {{ hasCoord
                                                        ? 'ดูโซน, BTS/MRT/ARL และที่อยู่ที่คำนวณจากพิกัดนี้ ก่อนเลือกว่าจะใช้ไหม'
                                                        : 'ใส่ Latitude และ Longitude ก่อน จึงจะตรวจได้' }}
                                                </small>
                                            </div>
                                        </b-form-group>

                                        <geo-preview-modal
                                            :visible.sync="isGeoModalVisible"
                                            :preview="geoPreview"
                                            :before-save="geoBeforeSave"
                                            @apply="applyGeoPreview"
                                            @skip="onGeoSkip"
                                            @cancel="cancelGeoPreview"
                                        />
                                </b-col>
                            </b-row>
                            <br/>
                            <b-row>
                                <b-col md="12">
                                    <h5>Facility</h5>
                                    <hr />
                                </b-col>

                                <b-col md="12">
                                    <b-form-group>
                                        <b-form-checkbox-group
                                            id="checkbox-group-1"
                                            v-model="form.facility_id"
                                            :options="facilityOptions"
                                            name="facility_id"
                                            class="demo-inline-spacing"
                                        />
                                    </b-form-group>
                                </b-col>

                                <b-col cols="12">
                                    <b-button variant="primary" type="submit">Submit</b-button>
                                </b-col>
                            </b-row>
                        </b-tab>

                        <b-tab title="Facility Images" v-if="house_pin_id">
                            <FacilityForm />
                        </b-tab>

                        <b-tab title="FAQ" v-if="house_pin_id">
                            <HousePinFAQ />
                        </b-tab>
                    </b-tabs>
                </form>
            </validation-observer>
        </b-card-actions>
    </div>
</template>

<script>
import {
    BTabs, BTab, BRow, BCol, BFormGroup, BFormInput, BFormCheckboxGroup,
    BFormRating, BFormTextarea, BButton, BBadge, BFormCheckbox,
} from 'bootstrap-vue'
import { VueAutosuggest } from 'vue-autosuggest'
import BCardActions from '../../../@core/components/b-card-actions/BCardActions.vue'
import { ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import { quillEditor } from 'vue-quill-editor'
import axios from '@axios'
import { MIN_USER_KEYWORD, searchUsers } from '@core/utils/user-autocomplete'
import vSelect from 'vue-select'
import ValidatedInput from '../../components/validate-input/ValidatedInput.vue'
import LocationSelector from '../../components/locationSelector/LocationSelector.vue'
import GeoPreviewModal from '../../property-pins/pin-form/GeoPreviewModal.vue'
import {
    LMap, LTileLayer, LMarker, LCircle, LPolygon,
} from 'vue2-leaflet'
import 'leaflet/dist/leaflet.css'
import { Icon } from 'leaflet'
import router from '@/router'
import FacilityForm from './FacilityForm.vue'
import HousePinFAQ from './HousePinFAQ.vue'

delete Icon.Default.prototype._getIconUrl
Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
})

export default {
    components: {
        BCardActions, BTabs, BTab, ValidationObserver, BFormCheckbox, BFormCheckboxGroup,
        BRow, BCol, BFormGroup, BFormInput, quillEditor, vSelect,
        BFormRating, BFormTextarea, BButton, BBadge, VueAutosuggest,
        ValidatedInput, LocationSelector, LMap, LTileLayer, LMarker, LCircle, LPolygon,
        FacilityForm, HousePinFAQ, GeoPreviewModal,
    },

    data() {
        const userData = JSON.parse(localStorage.getItem('userData'));

        return {
            house_pin_id: router.currentRoute.params.id,
            /*
             * popup "ตรวจจากพิกัด" — ตัวเดียวกับฟอร์มหมุดคอนโด (GeoPreviewModal.vue)
             * โซน / สถานี / ที่อยู่ คำนวณจากพิกัดบนเซิร์ฟเวอร์ แล้วให้คนเลือกก่อนใส่ฟอร์ม
             */
            geoPreview: null,
            isGeoModalVisible: false,
            isGeoLoading: false,
            /* true = popup ถูกเปิดจากปุ่มบันทึก กด "ใช้ค่านี้" แล้วต้องบันทึกต่อเลย */
            geoBeforeSave: false,
            languages: [],
            developerData: [],
            houseTypeData: [],
            btsData: [],
            mrtData: [],
            airportLinkData: [],
            zoneData: [],
            provinceOptions: [],
            amphureOptions: [],
            tambonOptions: [],
            facilities:[],
            form: {
                name: {},
                address: {},
                meta_title: {}, 
                meta_description: {},
                youtube: '',
                description: '',
                developer_id: null,
                type_id: [],
                rating: null,
                year: null,
                price_area: null,
                level: null,
                total_building: null,
                total_unit: null,
                comment: null,
                btsData: [],
                mrtData: [],
                airportLinkData: [],
                zoneId: [],
                province_id: null,
                amphure_id: null,
                tambon_id: null,
                zip_code: null,
                lattitude: null,
                longitude: null,
                created_by: null,
                is_active: true,
                facility_id: [],
                created_by: userData.id,
                updated_by: userData.id
            },
            url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
            zoom: 15,
            center: [47.313220, -1.319482],
            markerLatLng: [47.313220, -1.319482],
            circle: {
            center: [47.313220, -1.319482],
            radius: 4500,
                color: '#EA5455',
            },
            polygon: {
                color: '#7367F0',
            },
            suggestionscb: [],
            inputProps: {
                id: 'autosuggest__input_ajax',
                placeholder: 'Developer',
                class: 'form-control',
                name: 'develop',
            },
            sectionConfigs:{
                dev: {
                    label: 'User',
                    onSelected: selected => {
                        this.input.devlop_id = selected.item.id;
                    },
                },
                cb: {
                    label: 'User',
                    onSelected: selected => {
                        this.form.created_by = selected.item.id;
                    },
                },
                types: {
                    label: 'Type',
                    onSelected: selected => {
                    },
                }
            },
            created_by: null,
        }
    },

    computed: {
        hasCoord() {
            const lat = Number(this.form.lattitude)
            const lng = Number(this.form.longitude)

            return Number.isFinite(lat) && Number.isFinite(lng) && lat !== 0 && lng !== 0
        },
        currentLocale() {
            return this.$i18n.locale
        },
        houseTypeOptions() {
            return this.mapLocalizedOptions(this.houseTypeData, 'title')
        },
        btsOptions() {
            return this.mapLocalizedOptions(this.btsData)
        },
        mrtOptions() {
            return this.mapLocalizedOptions(this.mrtData)
        },
        airportLinkOptions() {
            return this.mapLocalizedOptions(this.airportLinkData)
        },
        zoneOptions() {
            return this.mapLocalizedOptions(this.zoneData)
        },
        facilityOptions() {
            const locale = this.currentLocale || 'en';
            return this.facilities
                .filter(facility => facility.is_active)
                .map(facility => ({
                    text: facility.name[locale] || facility.name.en || 'Unnamed',
                    value: facility.id
                }));
        },
    },
    created() {
        this.initData()
        let queryParams = {
            type_code:1,
            is_active: 1,
            order_by: "FIRST_LETTER ASC"
        }
        var data = JSON.stringify(queryParams);
            axios.post('facility/v1/lists', data)
            .then(res => {
                this.facilities = res.data.data; 
                
            })

        if(this.house_pin_id) {
            this.fetchExistingHousePin()
        }
    },
    methods: {
        /* คืน true เมื่อได้ผลมาแล้ว (popup เปิดให้เอง) */
        async checkCoord(beforeSave) {
            if (!this.hasCoord) {
                this.$bvToast.toast('กรุณาใส่ Latitude และ Longitude ก่อนตรวจ', { title: 'ต้องมีพิกัดก่อน', variant: 'danger' })

                return false
            }

            this.isGeoLoading = true

            try {
                const res = await axios.post('place/v1/geo/preview-by-coord', {
                    lat: this.form.lattitude,
                    lng: this.form.longitude,
                })

                this.geoPreview = res.data.data
                this.geoBeforeSave = !!beforeSave
                this.isGeoModalVisible = true

                return true
            } catch (error) {
                const message = error.response && error.response.data ? error.response.data.message : null

                this.$bvToast.toast(message || 'ลองใหม่อีกครั้ง', { title: 'ตรวจจากพิกัดไม่สำเร็จ', variant: 'danger' })

                return false
            } finally {
                this.isGeoLoading = false
            }
        },

        /* ปิด popup โดยไม่ทำอะไร — ต้องล้างธง ไม่งั้นกดบันทึกครั้งถัดไปจะข้าม popup ไปเลย */
        cancelGeoPreview() {
            this.isGeoModalVisible = false
            this.geoBeforeSave = false
        },

        /** เอาผลที่คำนวณได้ใส่ฟอร์ม ตามหัวข้อที่ติ๊กไว้ — ยังไม่บันทึกลง DB */
        async applyGeoPreview(parts) {
            const preview = this.geoPreview

            if (!preview) return

            if (parts.zone) this.form.zoneId = preview.zones.map(zone => zone.id)

            if (parts.transit) {
                /* LocationSelector เก็บเป็น { transitId, distance, duration } ตรงกับที่ popup ส่งมา */
                const rows = list => list.map(station => ({
                    transitId: station.id,
                    distance: station.distance,
                    duration: station.duration,
                }))

                this.form.btsData = rows(preview.bts)
                this.form.mrtData = rows(preview.mrt)
                this.form.airportLinkData = rows(preview.airport)
            }

            if (parts.address && preview.admin_area) {
                const area = preview.admin_area

                this.form.province_id = area.province_id
                /* ต้องโหลดรายการอำเภอ/ตำบลก่อน ไม่งั้น select จะโชว์ค่าว่างทั้งที่ id ถูกแล้ว */
                await this.onProvinceChange(area.province_id)
                this.form.amphure_id = area.amphure_id
                await this.onAmphureChange(area.amphure_id)
                this.form.tambon_id = area.tambon_id
                this.form.zip_code = area.zip_code || null
            }

            this.isGeoModalVisible = false

            if (this.geoBeforeSave) this.saveForm()
        },

        /** "บันทึกตามที่กรอกเอง" — ไม่เอาค่าที่คำนวณ แต่บันทึกต่อ */
        onGeoSkip() {
            this.isGeoModalVisible = false
            this.saveForm()
        },

        async fetchExistingHousePin() {
            try {
                const { data } = await axios.get(`/v1/house-pin/${this.house_pin_id}`);

                if (data?.success && data?.data) {
                    const { id, name, address, province_id, amphure_id, district_id, zip_code, developer_id,
                        responsible_id, btsData, mrtData, airportLinkData, zoneId, facility_id, meta_title,
                        meta_description, youtube_url, description, type_id, rating, year, total_unit, comment,
                        is_active, lattitude, longitude
                    } = data.data;

                    this.form.name = name || "";
                    this.form.address = address || "";
                    this.form.province_id = province_id || null;
                    this.form.amphure_id = amphure_id || null;
                    this.form.tambon_id = district_id || null;
                    this.form.zip_code = zip_code || null;
                    this.form.developer_id = developer_id || null;
                    this.form.responsible_id = responsible_id || null;
                    this.form.btsData = btsData || [];
                    this.form.mrtData = mrtData || [];
                    this.form.airportLinkData = airportLinkData || [];
                    this.form.zoneId = zoneId || [];
                    this.form.facility_id = facility_id || [];
                    this.form.type_id = type_id || null;
                    this.form.meta_title = meta_title || {};
                    this.form.meta_description = meta_description || {};
                    this.form.youtube = youtube_url || null;
                    this.form.description = description || null;
                    this.form.rating = rating || null;
                    this.form.year = year || null;
                    this.form.total_unit = total_unit || null;
                    this.form.comment = comment || null;
                    this.form.is_active = is_active? true: false;
                    this.form.lattitude = lattitude || null;
                    this.form.longitude = longitude || null;

                    await this.onProvinceChange(this.form.province_id)
                    await this.onAmphureChange(this.form.amphure_id)
                    await this.onTambonChange(this.form.tambon_id)
                }
            } catch (err) {
                console.error("Failed to fetch house pin:", err);
                // Optional: show a user-facing error (toast, alert, etc.)
            }
        },
        mapLocalizedOptions(data, key = 'name') {
            return data.map(g => ({
                id: g.id,
                name: g[key]?.[this.currentLocale] || g[key]
            }))
        },
        changePosition(){
            if(this.form.lattitude && this.form.longitude){
                this.center = [this.form.lattitude,this.form.longitude]
                this.markerLatLng = [this.form.lattitude,this.form.longitude]
                this.circle.center = [this.form.lattitude,this.form.longitude]
            }
        },
        async fetchAndSet(url, payload, target) {
            try {
                const { data } = await axios.post(url, payload)
                this[target] = data?.data || []
            } catch (error) {
                console.error(`Error fetching ${target}:`, error)
                this[target] = []
            }
        },
        async initData() {
            await Promise.all([
                this.fetchLanguages(),
                this.fetchAndSet('developer/v1/lists', { is_active: 1, perpage: 500, offset: 0 }, 'developerData'),
                this.fetchAndSet('v1/house-types', { is_active: 1, order_by: "ordering_count ASC" }, 'houseTypeData'),
                this.fetchAndSet('transit/v1/lists', { type_code: 'bts', is_active: 1 }, 'btsData'),
                this.fetchAndSet('transit/v1/lists', { type_code: 'mrt', is_active: 1 }, 'mrtData'),
                this.fetchAndSet('transit/v1/lists', { type_code: 'airport', is_active: 1 }, 'airportLinkData'),
                this.fetchAndSet('zone/v1/lists', { is_active: 1 }, 'zoneData'),
                this.fetchProvinces(),
            ])

            if (this.form.province_id) await this.onProvinceChange(this.form.province_id)
            if (this.form.amphure_id) await this.onAmphureChange(this.form.amphure_id)
            if (this.form.tambon_id) await this.onTambonChange(this.form.tambon_id)
        },
        async fetchLanguages() {
            try {
                const { data } = await axios.post('/languages/v1/getall', { is_active: 1 })
                this.languages = data?.data || []
            } catch (error) {
                console.error('Error fetching languages:', error)
                this.languages = []
            }
        },
        async fetchProvinces() {
            try {
                const { data } = await axios.get("address/v1/provinces")
                this.provinceOptions = data?.data.map(p => ({
                    id: p.id,
                    name: this.currentLocale === "th" ? p.name_th : p.name_en
                }))
            } catch (error) {
                console.error('Error fetching provinces:', error)
                this.provinceOptions = []
            }
        },
        async onProvinceChange(provinceId) {
            if (!provinceId) return
            try {
                const { data } = await axios.get(`amphures/${provinceId}`)
                this.amphureOptions = data?.data.map(a => ({
                    id: a.id,
                    name: this.currentLocale === "th" ? a.name_th : a.name_en
                }))

                this.tambonOptions = []
            } catch (error) {
                console.error('Error fetching amphures:', error)
                this.amphureOptions = []
            }
        },
        async onAmphureChange(amphureId) {
            if (!amphureId) return
            try {
                const { data } = await axios.get(`tambons/${amphureId}`)
                this.tambonOptions = data?.data.map(t => ({
                id: t.id,
                name: this.currentLocale === "th" ? t.name_th : t.name_en
                }))
            } catch (error) {
                console.error('Error fetching tambons:', error)
                this.tambonOptions = []
            }
        },
        async onTambonChange(tambonId) {
            if (!tambonId) return
            try {
                const { data } = await axios.get(`zipcode/${tambonId}`)
                this.form.zip_code = data?.data?.[0]?.zip_code || null
            } catch (error) {
                console.error('Error fetching zip code:', error)
                this.form.zip_code = null
            }
        },
        renderSuggestioncb(suggestion) {
            return suggestion.item.name
        },
        getSuggestionValuecb(suggestion) {
            const { name, item } = suggestion
            return name === 'hotels' ? item.title : item.name
        },
        fetchResultscb() {
            const { created_by } = this

            // One character matches ~6,000 users and the endpoint returns all of them; see user-autocomplete.js
            if(created_by && String(created_by).trim().length >= MIN_USER_KEYWORD){
                clearTimeout(this.timeout)
                this.timeout = setTimeout(() => {
                    searchUsers(created_by).then(data => {
                        this.suggestionscb = []
                        this.suggestionscb.push({ name: 'cb', data: data })
                    }).catch(error=>{
                        console.log('error', error)
                    })
                }, this.debounceMilliseconds)
            }else{
                this.suggestionscb = []
            }
        },
        async getFacs(){
            let facs = await axios.get('place/v1/getfacilities/'+this.id);
            let fa = [];

            if(facs.data.data){
                facs.data.data.filter(item => {
                    fa.push(item.facility_id);
                });
            }

            this.input.facility_id = fa;
        },
        async handleSubmit() {
            const observer = this.$refs.formObserver

            await observer.validate()

            /*
             * ⚠️ ไม่มีพิกัด = บันทึกไม่ได้
             * โซน / สถานี / ที่อยู่ / สถานที่ใกล้เคียง คำนวณจากพิกัดทั้งหมด
             */
            if (!this.hasCoord) {
                this.$bvToast.toast('กรุณาใส่ Latitude และ Longitude ก่อนบันทึก', { title: 'ต้องมีพิกัดก่อน', variant: 'danger' })

                return
            }

            /* หมุดใหม่: กางผลที่คำนวณจากพิกัดให้ดูก่อนเสมอ แล้วค่อยบันทึกจากปุ่มใน popup */
            if (!this.house_pin_id && !this.geoBeforeSave) {
                await this.checkCoord(true)

                return
            }

            await this.saveForm()
        },

        /** บันทึกจริง — แยกจาก handleSubmit เพื่อให้ popup เรียกต่อได้หลังคนกดยืนยัน */
        async saveForm() {
            this.geoBeforeSave = false

            if (!this.house_pin_id) {
                await axios.post('v1/house-pin/add', this.form)
            } else {
                this.form.id = this.house_pin_id
                await axios.patch('v1/house-pin/update', this.form)
            }
        }
    },
}
</script>


<style lang="scss">
@import '@core/scss/vue/libs/vue-autosuggest.scss';
@import '@core/scss/vue/libs/vue-select.scss';

.vue2leaflet-map {
  &.leaflet-container {
    height: 350px;
  }
}
</style>